<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">Certificações internacionais</a></li>
                            <li>Regras Para Isenção</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" @click="openCreate()">
                            Criar
                        </button>
                    </section>
                </div>
            </div>
            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Filtros</b></h2>
                    </div>
                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label for="nome">Nome</label>
                                    <input type="text" class="form-control" name="nome" placeholder="Nome da Regra" maxlength="150" v-model="filter.Nome" />
                                </div>

                                <div class="form-group col-md-3">
                                    <label for="Exame">Exame</label>
                                    <select v-select="{ dataitem: 'Interesse', default: 'Todos' }" v-model="filter.InteresseId" class="form-control" name="interesseId"></select>
                                </div>

                                <div class="form-group col-md-2">
                                    <label for="dataInicioVigencia">Data Início Vigência</label>
                                    <input type="text" v-datepicker class="form-control" autocomplete="off" id="dataInicioVigencia" name="dataInicioVigencia" v-model="filter.dataInicioVigenciaStart" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="dataTerminoVigenciaFilter">Data Término Vigência</label>
                                    <input type="text" v-datepicker class="form-control" autocomplete="off" id="dataTerminoVigencia" name="dataTerminoVigencia" v-model="filter.dataTerminoVigenciaEnd" />
                                </div>
                            </div>
                            <div class="form-group col-md-3">
                                <label>Situação</label>
                                <div class="form-group">
                                    <label class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" name="situacaoRegra" value="undefined" v-model="filter.ativo" class="custom-control-input">
                                        <span class="custom-control-indicator"></span>
                                        <span class="custom-control-description">Todos</span>
                                    </label>
                                    <label class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" name="situacaoRegra" value="true" v-model="filter.ativo" class="custom-control-input">
                                        <span class="custom-control-indicator"></span>
                                        <span class="custom-control-description">Ativo</span>
                                    </label>
                                    <label class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" name="situacaoRegra" value="false" v-model="filter.ativo" class="custom-control-input">
                                        <span class="custom-control-indicator"></span>
                                        <span class="custom-control-description">Inativo</span>
                                    </label>
                                </div>
                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                        <div class="row">
                            <div class="form-group col-md-11">
                                <div class="pull-right" style="color:red; font-size:small" id="errorsConsulta"></div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>#<i @click="executeOrderBy('certificacoesRegrasIsencaoId')" class="fa fa-sort"></i></th>
                                    <th>Exame</th>
                                    <th>Nome da Regra<i @click="executeOrderBy('nome')" class="fa fa-sort"></i></th>
                                    <th>Data Inicio Vigência<i @click="executeOrderBy('dataInicioVigencia')" class="fa fa-sort"></i></th>
                                    <th>Data Término Vigência<i @click="executeOrderBy('dataTerminoVigencia')" class="fa fa-sort"></i></th>
                                    <th>Situação</th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.certificacoesRegrasIsencaoId}}</td>
                                    <td>{{ item.interesse.nome }}</td>
                                    <td>{{ item.nome }}</td>
                                    <td>{{ item.dataInicioVigencia }}</td>
                                    <td>{{ item.dataTerminoVigencia }}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ativo, 'badge-danger': !item.ativo }">{{item.ativo ? 'Ativo' : 'Inativo'}}</span></td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-warning" v-b-tooltip title="Log de Alterações" @click="openLog({ certificacoesRegrasIsencaoId: item.certificacoesRegrasIsencaoId })">
                                            <i class="fa fa-history"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Editar Regra" @click="openEdit({ certificacoesRegrasIsencaoId: item.certificacoesRegrasIsencaoId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>
                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Nova Regra">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar Regra">
            <form-edit v-if="dialogEdit" :id="certificacoesRegrasIsencaoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogLog" :hide-footer="true" title="Log de Alterações">
            <form-log v-if="dialogLog" :id="certificacoesRegrasIsencaoId" style="max-height: 400px; overflow-x: hidden; overflow-y: auto;" @on-back="hideAll()" />
        </b-modal>
    </main>

</template>
<script>
    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'
    import formLog from './form-log'

    export default {
        name: 'certificacoesregrasisencao',
        mixins: [base],
        components: { formCreate, formEdit, formLog },
        data() {
            return {

                dialogCreate: false,
                dialogEdit: false,
                dialogLog: false,
                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },
                result: {
                    total: 0,
                    items: []
                },
                resources: {
                    filter: 'certificacoesregrasisencao'
                },
            }
        },
        methods: {

            openEdit: function (model) {
                this.certificacoesRegrasIsencaoId = model.certificacoesRegrasIsencaoId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            openLog: function (model) {
                this.certificacoesRegrasIsencaoId = model.certificacoesRegrasIsencaoId;
                this.dialogLog = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogLog = false;

            },
            executeFilter: function (filter) {
                var dataInicio = document.getElementById('dataInicioVigencia').value;
                var dataFim = document.getElementById('dataTerminoVigencia').value;
                if (dataFim != "") {
                if (dataInicio > dataFim) {
                    document.getElementById('errorsConsulta').innerHTML = "*Erro. Informe uma data de término posterior a data de início.*";
                    return false;
                    }
                }
                document.getElementById('errorsConsulta').innerHTML = "";
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },

            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },
        },
        mounted() {
            this.executeFilter();
        }
    };
</script>